<div class="desktop-container">
    <div>
        <span class="intro">
            @if (issue ; as issue) {
                <div>
                    <h3 class="p-0 m-0">{{ issue.title }}</h3>
                    <p>You were made responsible of this safety case by {{ (issue.assignedBy ?? issue.creator) | userFullName }}</p>
                </div>
                    
            }
        </span>
 
    </div>
    <div class="form-type type-case">
        Case
    </div>
    <app-flight-card-cta class="w-full" [flight]="issue" [type]="'issue'" [isEditable]="showEdit" [canBeArchived]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
  <app-combined-task-card-mobile
    [data]="issue"
    [type]="'issue'"
    [showEdit]="showEdit"
  ></app-combined-task-card-mobile>
</div>
